import * as t from 'io-ts';
import { Reporter } from 'io-ts/lib/Reporter';

export const ioTsRequired = t.refinement(t.string, str => str.trim().length !== 0, 'required');
export const ioTsIsTrue = t.refinement(t.boolean, value => value === true, 'istrue');

export const ioTsEmail = t.refinement(
  t.string,
  str => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    return regex.test(str);
  },
  'email'
);

export const ioTsPhone = t.refinement(
  t.string,
  str => {
    const regex = /^[\d-+]+$/;

    return regex.test(str);
  },
  'phone'
);

function setUnionAndIntersectionValidation(value: any, type: any) {
  let errors: string[] = [];

  type.types.forEach((elem: any) => {
    if (!t.exact(elem).decode(value).isRight()) {
      errors = errors.concat(elem.name);
    }
  });

  return errors;
}

export function ioTsValidation(errors: any) {
  let typesErrors = {};
  errors.map((e: any) => {
    e.context.map(({ key, type }: { key: any; type: any }) => {
      const anytype: any = type;

      if (anytype && anytype._tag !== 'InterfaceType') {
        if (anytype._tag === 'IntersectionType' || anytype._tag === 'UnionType') {
          typesErrors = Object.assign({}, typesErrors, {
            [key]: {
              errors: setUnionAndIntersectionValidation(e.value, anytype),
            },
          });
        } else {
          typesErrors = Object.assign({}, typesErrors, {
            [key]: { errors: [anytype.name] },
          });
        }
      }
    });
  });

  return typesErrors;
}

export const validReporter: Reporter<{}> = {
  report: validation =>
    validation.fold(
      errors => ioTsValidation(errors),
      () => true
    ),
};
